import { IIconProps, ISearchBoxStyles, SearchBox } from "@fluentui/react"
import * as React from "react"
import { LanguageContext } from "../utilities/LocalizationModule";

const filterIcon: IIconProps = { iconName: "PageListFilter" };
const searchBoxStyles: Partial<ISearchBoxStyles> = {
    root: { width: 300, height: "100%" }
};

export const useQuickFilterCommandInput = (setQuickFilterValue: (filterValue: string) => void) => {
    const languageStrings = React.useContext(LanguageContext);

    const [privateQuickFilterValue, setPrivateQuickFilterValue] = React.useState<string>();

    React.useEffect(() => {
        const timeOutId = setTimeout(() => {
            setQuickFilterValue(privateQuickFilterValue?.trim());
        }, 500);
        return () => clearTimeout(timeOutId);
    }, [privateQuickFilterValue]);

    const onChangeFilter = React.useCallback((event?: React.ChangeEvent<HTMLInputElement>, newValue?: string) => {
        setPrivateQuickFilterValue(newValue);
    }, []);

    const onSearchFilter = React.useCallback((filterText: any) => {
        setQuickFilterValue(filterText?.trim());
    }, []);

    const onClearFilter = React.useCallback(() => {
        setQuickFilterValue("");
    }, []);

    const resetQuickFilterValue = React.useCallback(() => {
        setPrivateQuickFilterValue(null);
        setQuickFilterValue(null);
    }, []);

    const onQuickFilterCommandInputRender = React.useCallback(() => {
        return <SearchBox
            styles={searchBoxStyles}
            placeholder={languageStrings.FilterResults}
            iconProps={filterIcon}
            underlined={true}
            value={privateQuickFilterValue ?? ""}
            onChange={onChangeFilter}
            onSearch={onSearchFilter}
            onClear={onClearFilter}
            showIcon={true}
        />
    }, [privateQuickFilterValue]);

    const quickFilterCommandInput = React.useMemo(() => ({
        key: "QuickFilter",
        onRender: onQuickFilterCommandInputRender
    }), [privateQuickFilterValue]);

    return {
        quickFilterCommandInput,
        resetQuickFilterValue
    }
}